<div class="column edit-toggle-page">
	<div class="content-container">
		<div class="content-container-header flex-row-end">
			<h3 class="flex-grow" i18n="@@contactNotificationMain-contactNotificationMainTitle">
				Contacts for Notifications
			</h3>

			@if (canEdit) {
				@if (!isEditing) {
					<div class="spacing-24 flex-fixed">
						<button
							mat-button
							i18n="@@contactNotificationMain-edit"
							class="primary-button"
							data-automation-id="contact-list-edit-button-in-client"
							(click)="editBtnClick()"
						>
							Edit
						</button>
					</div>
				}
			}

			@if (isEditing) {
				<div class="flex-fixed flex-row">
					<div class="flex-1">
						<button
							mat-button
							i18n="@@contactNotificationMain-cancel"
							class="secondary-button"
							data-automation-id="contact-list-cancel-button"
							(click)="cancelClick()"
						>
							Cancel
						</button>
					</div>
					<div class="flex-1">
						<app-loading-indicator diameter="35">
							<button
								mat-button
								i18n="@@contactNotificationMain-save"
								class="primary-button"
								data-automation-id="contact-list-save-changes-button"
								(click)="saveBtnClick()"
								[disabled]="isSaveBtnDisable"
							>
								Save
							</button>
						</app-loading-indicator>
					</div>
				</div>
			}
		</div>

		<mat-divider></mat-divider>

		<!-- Load the list of contacts and after click on Edit load the Add / Edit contact : -->
		@if (!isEditing) {
			<app-list-of-contact
				[displayedColumns]="displayedColumns"
				[dataSource]="dataSource"
				[isEditing]="isEditing"
				[clientId]="clientId"
			></app-list-of-contact>
		} @else {
			<app-add-edit-contact
				[contactDetailData]="dataSource.data"
				[clientId]="clientId"
				[saveClickedFlag]="btnSaveClick"
				(formDataSubmitted)="onFormDataSubmitted($event)"
				(updatedListAfterAddNewRow)="updatedListAfterNewRow($event)"
			></app-add-edit-contact>
		}
	</div>
</div>
